import { Checkbox } from "@equidefi/ui/forms";
import type { CheckboxProps } from "@equidefi/ui/forms/Checkbox";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartCheckboxProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<CheckboxProps, "name" | "error" | "isInvalid" | "isChecked" | "value" | "onChange" | "onBlur"> & {
  name: TName;
};

function SmartCheckbox<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...checkboxProps }: SmartCheckboxProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field: { value, onChange, ...field },
    fieldState: { error },
  } = useController<TFieldValues, TName>({ name, control });

  return (
    <Checkbox
      {...field}
      isChecked={!!value}
      onChange={(e) => onChange(e.target.checked)}
      isInvalid={!!error}
      error={error?.message}
      {...checkboxProps}
    />
  );
}

export default SmartCheckbox;
